import { render, staticRenderFns } from "./admins.vue?vue&type=template&id=1a56943a&scoped=true"
import script from "./admins.vue?vue&type=script&lang=js"
export * from "./admins.vue?vue&type=script&lang=js"
import style0 from "./admins.vue?vue&type=style&index=0&id=1a56943a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a56943a",
  null
  
)

export default component.exports